<template>
  <v-text-field
    v-bind="defaultConfigs"
    v-on="$listeners"
    :class="className"
    :autofocus="$vuetify.breakpoint.lgAndUp ? isAutoFocus : false"
    :style="inputStyles"
  >
    <template v-slot:append v-if="isClearable && $attrs.value">
      <div @click="handleClear" style="cursor: pointer" class="mt-2">
        <SvgIcon name="remove" color="purple100" />
      </div>
    </template>
    <template v-slot:append-outer>
      <div @click="$emit('click:append-outer')">
        <SvgIcon
          name="search"
          color="white"
          v-if="isSidebar && $vuetify.breakpoint.smAndDown"
          class="mt-2 base-filter-icon"
        />
        <SvgIcon
          name="search"
          color="gray70"
          class="mt-2 base-filter-icon"
          v-else
        />
      </div>
    </template>
  </v-text-field>
</template>
<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class BaseFilter extends Vue {
  @Prop({ default: "gray15" }) colorInput: string;
  @Prop({ default: true }) isAutoFocus: string;
  @Prop({ default: false }) isSidebar: string;
  @Prop({ default: true }) isClearable: boolean;
  @Prop({ default: "base-filter" }) className: string;

  get defaultProp() {
    return {
      outlined: true,
      dense: true,
      "background-color": this.colorInput,
    };
  }
  get defaultConfigs(): any {
    return {
      ...this.$attrs,
      ...this.$props,
      ...this.defaultProp,
    };
  }
  get inputStyles(): any {
    const fontSize = this.$vuetify.breakpoint.lgAndUp ? "14px" : "12px";
    const lineHeight = "20px";
    return {
      "--v-text-field-input-font-size": fontSize,
      "--v-text-field-input-line-height": lineHeight,
      fontSize: fontSize,
      lineHeight: lineHeight,
      fontWeight: 400,
    };
  }
  handleClear(): void {
    this.$emit("click:clear");
  }
}
</script>
<style lang="sass">
.v-text-field--outlined.base-filter fieldset, .v-text-field.base-filter .v-input__control .v-input__slot
  border: 1px solid var(--v-gray35-base)
  border-radius: 8px
.v-input__append-inner .v-input__icon--append i
  color:  var(--v-gray50-base)
  width: 20px !important
  height: 20px !important
  padding-top: 5px
.base-filter
  .v-text-field__details
    display: none !important
.base-filter-select
  .v-text-field__details
    display: none !important
.v-input__icon--clear, .v-input__icon--append-outer
  margin-top: 5px !important
.base-filter-icon
  cursor: pointer
.v-text-field--outlined.base-filter-select fieldset, .v-text-field.base-filter-select .v-input__control .v-input__slot
  border: 1px solid rgba(0, 0, 0, .23)
  border-radius: 8px
</style>
